module.exports = __webpack_public_path__ + "img/IERABNED.674d4f49.png";